import { useEffect, useState } from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
import Spinner from '../StoraEnsoComponents/Spinner';
import { getProjectThumbnail } from '../../services/mapService';
import { ReactComponent as ErrorSvg } from '../../assets/icons/circle-exclamation-solid.svg'

const Img = styled.img`
  display: block;
  flex: 0 0 auto;
  padding: 0;
  position: relative;
  max-width: 100%;
`;

const ErrorIcon = styled(ErrorSvg)`
    width: 30px;
    height: auto;
    fill: #cf142b;
    margin-bottom: 16px;
`;

const Wrapper = styled.div`
    height: 150px;
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #646f76;

    .se-spinner {
        margin-bottom: 16px;
    }
`;

const ErrorMessage = styled.span`
    color: #cf142b;
`;

function Thumbnail({ id }) {
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    getProjectThumbnail(id)
      .then(data => {
        setData(data);
      })
      .catch(() => {
        setShowError(true);
        console.error('Cannot download project thumbnail.')
      })
      .then(() => setLoading(false));
  }, [id]);

  if (isLoading) {
    return (
      <Wrapper>
        <Spinner />
        <span>Loading preview...</span>
      </Wrapper>
    );
  }

  if (showError) {
    return (
      <Wrapper>
        <ErrorIcon />
        <ErrorMessage>An error has occurred!</ErrorMessage>
      </Wrapper>
    )
  }

  return (
    <Img src={URL.createObjectURL(data)} />
  );
}

Thumbnail.propTypes = {
  id: string.isRequired,
};

export default Thumbnail;
